/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { absDependencies } from './dependenciesAbs.generated';
import { mapDependencies } from './dependenciesMap.generated';
import { medianDependencies } from './dependenciesMedian.generated';
import { subtractDependencies } from './dependenciesSubtract.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createMad } from '../../factoriesAny.js';
export var madDependencies = {
  absDependencies: absDependencies,
  mapDependencies: mapDependencies,
  medianDependencies: medianDependencies,
  subtractDependencies: subtractDependencies,
  typedDependencies: typedDependencies,
  createMad: createMad
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesMad.generated.js
// module id = 1447
// module chunks = 0